import { unitStrict } from '@lib/style/unit';
import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';

const WIDTH = 280;

export const SDrawer = styled(Drawer).attrs(() => ({
    PaperProps: {
        classes: {
            root: 'sidebar__content',
        },
    },
}))`
    & {
        transform: translate3d(0, 0, 0);
        transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
        &.persistent {
            z-index: 3;
            width: 0;
            &.active {
                width: ${unitStrict(WIDTH + 1)};
            }
        }

        &.mobile {
            .sidebar__content {
                width: ${unitStrict(WIDTH)};
            }
        }

        .sidebar {
            &__list {
                width: ${unitStrict(WIDTH)};
                max-width: ${unitStrict(WIDTH)};
                .MuiListItem-root {
                    .MuiListItemIcon-root {
                        min-width: 38px;
                    }
                }
                .MuiList-root {
                    padding-top: 0;
                    .MuiListItem-root {
                        padding-left: 68px;
                    }
                }
            }
            &__profile {
                padding: 0 !important;
            }
            &__content {
                transform: translate3d(0, 0, 0);
                position: relative;
                overflow: initial;
                border-right: 1px solid #e0e0e0;
            }
        }
    }
`;
